module.exports = __webpack_public_path__ + "static/media/57.15692bf6.svg";